import { t } from '@/lib/helpers'

import { NavItem } from '../types'

export const navsData: NavItem[] = [
  {
    title: t('views.components.layout.nav.manage_cookie'),
    href: '/projects',
    checkActive: [
      'domains',
      'domainConsent',
      'domainCustomize',
      'domainCookiesScanner',
      'domainManageCookies',
      'domainPreview',
      'domainBannerSettings',
    ],
    feature: 'project',
  },
  {
    title: t('views.components.layout.nav.packages'),
    href: '/packages',
    checkActive: [
      'packages',
      'freeTrial',
      'receipts',
      'checkout',
      'pageViews',
      'payments',
      'paymentsSuccess',
    ],
    feature: 'payment',
  },
]

export const subLinks: NavItem[] = [
  {
    title: t('views.components.layout.nav.user_managements'),
    href: '/user_managements',
    checkActive: ['userManagements', 'activityLogs'],
    feature: 'user_management',
  },
  {
    title: t('views.components.layout.nav.activity_log'),
    href: '/activity_logs',
    checkActive: ['userManagements', 'activityLogs'],
    feature: 'activity_log',
  },
]

export const helpCenterLinks: NavItem[] = [
  {
    title: t('views.components.layout.nav.quick_start_guide'),
    href: 'https://cookiewow.com/help/cookie-wow-tutorials/cookie-wow-quick-start-guide-cookie-banner',
    checkActive: [],
  },
  {
    title: t('views.components.layout.nav.documentation'),
    href: 'https://cookiewow.com/help',
    checkActive: [],
  },
]
